import { IFormValues } from '~/ui/components/reusable/MedicationForm/types';

const initialValues: IFormValues = {
  content: '',
};

export default initialValues;
